import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface User {
  id: string;
  name: string;
  userName: string;
  emailId: string;
  userType: string;
  userRole: string;
  phoneNo: string;
  mfaActive: boolean;
  contactVerified: boolean;
  createdBy: string;
  createdAt: string;
  potentialList?: any[];
}

export interface DecryptPasswordRequest {
  data: string;
  operation: string;
}

export interface DecryptPasswordResponse {
  success: boolean;
  data?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  private readonly cfIssuesRoleNames = ['access cf issues', 'cf issues', 'cf check', 'cf checker', 'cfcheck'];
  private readonly cfIssuesPrivilegeName = 'cf issues';

  constructor(private http: HttpClient) { }

  private getCurrentUserEmail(): string {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return (currentUser?.email || '').toLowerCase().trim();
  }

  private normalizeFeatureName(name: string): string {
    return (name || '')
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private getNormalizedCurrentUserRoles(): string[] {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const rawRoles = currentUser?.role;

    if (Array.isArray(rawRoles)) {
      return rawRoles
        .map((role: any) => this.normalizeFeatureName(String(role)))
        .filter(Boolean);
    }

    if (typeof rawRoles === 'string') {
      return rawRoles
        .split(',')
        .map((role: string) => this.normalizeFeatureName(role))
        .filter(Boolean);
    }

    return [];
  }

  private hasCfIssuesPrivilege(): boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const privileges = Array.isArray(currentUser?.privileges) ? currentUser.privileges : [];
    return privileges.some((privilege: string) =>
      this.normalizeFeatureName(privilege) === this.cfIssuesPrivilegeName
    );
  }

  private hasCfIssuesRole(): boolean {
    const roles = this.getNormalizedCurrentUserRoles();
    return roles.some((role: string) =>
      this.cfIssuesRoleNames.includes(role)
    );
  }

  /**
   * Fetch list of all users
   */
  getUsersList(): Observable<any> {
    const url = `${environment.workSpaceAPI}/user/getAll`;
    return this.http.get(url);
  }

  currentValue(val: string): Observable<any> {
    const url = `${environment.workSpaceAPI}/process`;
    const payload: DecryptPasswordRequest = {
      data: val,
      operation: 'decrypt'
    };
    return this.http.post(url, payload, { responseType: 'text' });

  }

  isSuperAdmin(): boolean {
    return this.getCurrentUserEmail() === 'sudarshan.chippa@pro-vigil.com';
  }

  canAccessCfIssues(): Observable<boolean> {
    return of(this.isSuperAdmin() || this.hasCfIssuesRole() || this.hasCfIssuesPrivilege());
  }
} 